/* ============================================================
   <spring-statement-logos> — pause/play toggle for the mobile
   auto-scroll logos marquee (WCAG 2.2.2: touch users need a
   visible pause control; hover/focus-within pause doesn't exist
   on touch devices). The marquee itself is pure CSS; this only
   toggles the paused state + button labels.
   ============================================================ */

class SpringStatementLogos extends HTMLElement {
  connectedCallback() {
    const marquee = this.querySelector('[data-marquee]');
    const toggle = this.querySelector('[data-marquee-toggle]');
    if (!marquee || !toggle) return;

    toggle.addEventListener('click', () => {
      const paused = marquee.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? 'Play logos' : 'Pause logos');
    });
  }
}

if (!customElements.get('spring-statement-logos')) {
  customElements.define('spring-statement-logos', SpringStatementLogos);
}
